import React, { useEffect, useState } from 'react';
import { Save, Loader2, Plus, X } from 'lucide-react';
import { getSettings, adminUpdateSettings } from '../../lib/api';
import { useSettings } from '../../lib/SettingsContext';
import { useToast } from '../../hooks/use-toast';
import ImageUploader from '../../components/admin/ImageUploader';
import I18nField from '../../components/admin/I18nField';

export default function AdminAjustes() {
  const { refresh } = useSettings();
  const { toast } = useToast();
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { getSettings().then(setS); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await adminUpdateSettings(s);
      await refresh();
      toast({ title: 'Ajustes guardados' });
    } catch { toast({ title: 'Error', variant: 'destructive' }); }
    setSaving(false);
  };

  if (!s) return <div className="p-10"><Loader2 className="animate-spin text-[#c9a063]" /></div>;

  const updateHero = (i, v) => setS({ ...s, hero_images: s.hero_images.map((x, idx) => idx === i ? v : x) });
  const addHero = () => setS({ ...s, hero_images: [...s.hero_images, ''] });
  const removeHero = (i) => setS({ ...s, hero_images: s.hero_images.filter((_, idx) => idx !== i) });

  return (
    <div className="p-6 md:p-10 max-w-4xl">
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif-display text-3xl text-white mb-1">Ajustes del sitio</h1><p className="text-white/55">Textos, imágenes y datos de contacto</p></div>
        <button onClick={save} disabled={saving} className="gd-btn-gold px-6 py-2.5 text-[11px] uppercase tracking-[0.3em] font-medium inline-flex items-center gap-2">{saving ? <Loader2 className="animate-spin" size={13} /> : <Save size={13} />} Guardar</button>
      </div>

      <div className="space-y-8">
        <Section title="Hero (cabecera)">
          <Field label="Título línea 1"><I18nField value={s.hero_title_line1} onChange={(v) => setS({ ...s, hero_title_line1: v })} testId="settings-hero-line1" /></Field>
          <Field label="Título línea 2"><I18nField value={s.hero_title_line2} onChange={(v) => setS({ ...s, hero_title_line2: v })} testId="settings-hero-line2" /></Field>
          <Field label="Subtítulo"><I18nField type="textarea" rows={2} value={s.hero_subtitle} onChange={(v) => setS({ ...s, hero_subtitle: v })} testId="settings-hero-subtitle" /></Field>
          <div>
            <div className="flex justify-between items-center mb-2"><label className="text-[10px] tracking-widest text-white/50 uppercase">Imágenes del hero ({s.hero_images.length})</label><button onClick={addHero} className="text-xs text-[#c9a063] hover:underline inline-flex items-center gap-1"><Plus size={11} /> Añadir</button></div>
            <div className="space-y-3">
              {s.hero_images.map((img, i) => (
                <div key={i} className="border border-white/10 p-3">
                  <div className="flex items-center justify-between mb-2"><span className="text-[10px] tracking-widest text-[#c9a063] uppercase">Imagen {i + 1}</span><button onClick={() => removeHero(i)} className="text-white/40 hover:text-red-400"><X size={14} /></button></div>
                  <ImageUploader value={img} onChange={(v) => updateHero(i, v)} folder="general" specKey="hero" />
                </div>
              ))}
            </div>
          </div>
        </Section>

        <Section title="Club / sobre nosotros">
          <Field label="Título (home)"><I18nField value={s.about_title} onChange={(v) => setS({ ...s, about_title: v })} testId="settings-about-title" /></Field>
          <Field label="Texto (home)"><I18nField type="textarea" rows={4} value={s.about_text} onChange={(v) => setS({ ...s, about_text: v })} testId="settings-about-text" /></Field>
          <Field label="Intro Quiénes Somos"><I18nField type="textarea" rows={4} value={s.quienes_intro} onChange={(v) => setS({ ...s, quienes_intro: v })} testId="settings-quienes-intro" /></Field>
        </Section>

        <Section title="Contacto">
          <Field label="Teléfono"><input value={s.contact_phone} onChange={(e) => setS({ ...s, contact_phone: e.target.value })} className={inputCls} /></Field>
          <Field label="Email"><input value={s.contact_email} onChange={(e) => setS({ ...s, contact_email: e.target.value })} className={inputCls} /></Field>
          <Field label="Dirección"><input value={s.contact_address} onChange={(e) => setS({ ...s, contact_address: e.target.value })} className={inputCls} /></Field>
        </Section>

        <Section title="Redes sociales">
          <Field label="Instagram"><input value={s.social_instagram} onChange={(e) => setS({ ...s, social_instagram: e.target.value })} className={inputCls} /></Field>
          <Field label="Facebook"><input value={s.social_facebook} onChange={(e) => setS({ ...s, social_facebook: e.target.value })} className={inputCls} /></Field>
          <Field label="LinkedIn"><input value={s.social_linkedin} onChange={(e) => setS({ ...s, social_linkedin: e.target.value })} className={inputCls} /></Field>
        </Section>
      </div>
    </div>
  );
}

const inputCls = 'bg-zinc-950 border border-white/10 text-white/90 px-3 py-2 text-sm focus:border-[#c9a063] focus:outline-none w-full';
const Field = ({ label, children }) => <div><label className="text-[10px] tracking-widest text-white/50 uppercase block mb-1.5">{label}</label>{children}</div>;
const Section = ({ title, children }) => (
  <div className="gd-card p-6">
    <h2 className="font-serif-display text-xl text-white mb-5 pb-3 border-b border-white/10">{title}</h2>
    <div className="space-y-4">{children}</div>
  </div>
);
